import words from '../assets/localewords.json'
import { SU } from './session_utils'

// https://www.nxworld.net/js-array-chunk.html
const arrayChunk = ([...array], size = 1) => {
  return array.reduce((acc, _value, index) => index % size ? acc : [...acc, array.slice(index, index + size)], [])
}

const getWords = (key, language) => {
  const word = words[key] ? words[key][language] : ''
  return word
}

const getAuthHeader = () => {
  return {
    Authorization: 'Bearer ' + SU.getToken(),
    'Content-Type': 'application/json;charset=UTF-8'
  }
}

const getSimpleFetchParams = () => {
  return {
    mode: 'cors',
    cache: 'no-cache',
    headers: getAuthHeader()
  }
}

const isUorNull = (value) => {
  if (typeof value === 'undefined' || value == null) {
    return true
  }
  return false
}

const isUorNorBlank = (str) => {
  if (isUorNull(str)) {
    return true
  }
  if (str === '') {
    return true
  }
  return false
}

const metaInfo = {
  htmlAttrs: {
    lang: 'ja'
  },
  meta: [
    { name: 'google', content: 'notranslate' },
    { 'http-equiv': 'Content-Language', content: 'ja' }
  ]
}

const queryKeyValueString = (key, value) => {
  return key + '=' + value
}

const zeroPaddingString = (num, digit) => {
  return (Array(digit).join('0') + num).slice(-digit)
}

const getDayDateString = (date, separator) => {
  const yy = date.getFullYear()
  const mStr = zeroPaddingString(date.getMonth() + 1, 2)
  const dStr = zeroPaddingString(date.getDate(), 2)
  return '' + yy + separator + mStr + separator + dStr
}

const getDayTimeString = (date, separator) => {
  const mStr = zeroPaddingString(date.getMinutes(), 2)
  const hStr = zeroPaddingString(date.getHours(), 2)
  return '' + hStr + separator + mStr
}

const getMonthDayString = (date, separator) => {
  const mStr = zeroPaddingString(date.getMonth() + 1, 2)
  const dStr = zeroPaddingString(date.getDate(), 2)
  return '' + mStr + separator + dStr
}

const getUnixTimeOfMonth = (date, nextMonthFlag) => {
  let yy = date.getFullYear()
  let m = date.getMonth()
  if (nextMonthFlag) {
    if (m === 11) {
      yy = yy + 1
      m = 0
    } else {
      m = m + 1
    }
  }
  const mStr = zeroPaddingString(m + 1, 2)
  const d2 = new Date('' + yy + '/' + mStr + '/01 00:00')
  return d2.getTime()
}

const getUnixTimeOfDay = (date) => {
  let eDay = new Date(date)
  eDay.setHours(0, 0, 0, 0)
  return eDay.getTime()
}

const getFileExt = (fileName) => {
  const ext1 = fileName.split('.')
  if (ext1.length > 0) {
    const ext2 = ext1[ext1.length - 1]
    return ext2.toLowerCase()
  }
  return ''
}

const makeRandomString = (len) => {
  const lLetters = 'abcdefghijklmnopqrstuvwxyz'
  const uLetters = lLetters.toUpperCase()
  const numbers = '0123456789'
  const totalLetters = lLetters + uLetters + numbers
  let password = ''
  password = ''
  for (let i = 0; i < len; i++) {
    password += totalLetters.charAt(Math.floor(Math.random() * totalLetters.length))
  }
  return password
}

// URIなのでdata://------,base64,---- となっているので注意
const blobToBase64 = (blob) => {
  const reader = new FileReader()
  reader.readAsDataURL(blob)
  return new Promise(resolve => {
    reader.onloadend = () => {
      console.log('onloaded')
      resolve(reader.result)
    }
  })
}

const getImageDataURI = (arrayB, ext) => {
  const encodedData = btoa(
    Array.from(
      new Uint8Array(arrayB),
      x => String.fromCharCode(x)
    ).join('')
  )
  return `data:image/${ext};base64,${encodedData}`
}

const downloadCsv = (csvstr, filename, document) => {
  const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
  const blob = new Blob([bom, csvstr], { type: 'text/csv' })
  downloadATag(document, filename, blob)
}

const downloadText = (text, filename, document) => {
  const blob = new Blob([text], { type: 'text/plain' })
  downloadATag(document, filename, blob)
}

const downloadBlob = (blob, filename, document) => {
  downloadATag(document, filename, blob)
}

const downloadImg = (arrayB, filename, document) => {
  const ext = getFileExt(filename)
  const blob = new Blob([arrayB], { type: 'image/' + ext })
  downloadATag(document, filename, blob)
}

const downloadATag = (document, filename, blob) => {
  if (window.navigator.msSaveOrOpenBlob) {
    // msSaveOrOpenBlobの場合はファイルを保存せずに開ける
    window.navigator.msSaveOrOpenBlob(blob, filename)
  } else if (window.navigator.msSaveBlob) {
    window.navigator.msSaveBlob(blob, filename)
  } else {
    const link = document.createElement('a')
    const url = window.URL.createObjectURL(blob)
    link.download = filename
    link.href = url
    link.click()
    window.URL.revokeObjectURL(url)
    link.remove()
  }
}

const normdist = (z, mean, sigma, bool) => {
  let z2 = z
  if (bool) {
    const k = 0.0000001
    const lp = 100000000
    let num = 0
    for (let i = 0; i < k * lp; i += k) {
      num += normdist(z2, mean, sigma, false) * k
      z2 += k
    }
    let ans = 1 - num
    return Math.round(ans * 1000000000) / 1000000000
  } else {
    const l = 1 / Math.sqrt(2 * Math.PI * (sigma * sigma))
    const zz = -1 * (z - mean) * (z - mean)
    let ans = l * Math.exp(zz / (2 * (sigma * sigma)))
    return Math.round(ans * 1000000000) / 1000000000
  }
}

export const CF = {
  arrayChunk,
  getWords,
  getAuthHeader,
  getSimpleFetchParams,
  getDayDateString,
  getDayTimeString,
  getMonthDayString,
  isUorNull,
  isUorNorBlank,
  blobToBase64,
  downloadCsv,
  downloadText,
  downloadBlob,
  zeroPaddingString,
  metaInfo,
  queryKeyValueString,
  getImageDataURI,
  getFileExt,
  downloadImg,
  getUnixTimeOfMonth,
  getUnixTimeOfDay,
  normdist,
  makeRandomString
}
